import React, {Component, Fragment} from "react";
import PageHeaderLayout from '../../layout/PageHeaderLayout'
import StandardTable from "../../components/StandardTable";
import {Card, Button, Divider, Modal, Upload, Icon, Popconfirm, Input} from "antd";
import authWrapper from "../../utils/authWrapper";
import * as api from "../../api/order_mould";
import * as qiniu from "../../utils/qiniu";
import * as utils from "../../utils/utils";
import FormModal from "../../components/FormModal";


const UploadButton = authWrapper('upload')(Button)
const DeleteFragment = authWrapper('delete')(Fragment)
const LocationFragment = authWrapper('location')(Fragment)


class OrderMould extends Component {

    state = {
        uploadModalVisible: false,
        uploading: false,
        files: [],
        locationModalVisible: false,
        locationModalSaving: false,
        locationModalRecord: {},
        searchKeyword: null
    }

    columns = [
        {
            title: '模具编号',
            dataIndex: 'mould_no'
        },
        {
            title: '库位',
            dataIndex: 'location_no'
        },
        {
            title: '操作',
            render: (record) => (
                <span>
                    <a onClick={() => window.open(record.path)}>查看</a>
                    <LocationFragment>
                        <Divider type='vertical'/>
                        <a onClick={() => this.onLocationModalOpen(record)}>库位</a>
                    </LocationFragment>
                    <DeleteFragment>
                        <Divider type='vertical'/>
                        <Popconfirm title={'是否确认删除'} onConfirm={() => this.onDelete(record.mould_no)}>
                            <a>删除</a>
                        </Popconfirm>
                    </DeleteFragment>
            </span>
            )
        }
    ]

    locationFields = [
        {
            dataIndex: 'mould_no',
            visible: false
        },
        {
            title: '库位',
            dataIndex: 'location_no'
        },
    ]

    dataTable = null

    onUploadModalOk = () => {
        const files = this.state.files.map(item => {
            const [mouldNo] = utils.splitFileName(item.name)
            return {
                file: item,
                key: `mould/${utils.extendFileName(item.name)}`,
                putExtra: {
                    params: {'x:mouldNo': mouldNo}
                }
            }
        })
        this.setState({uploading: true})
        qiniu.upload(files, 'order_mould').then(() => {
            this.setState({uploading: false, uploadModalVisible: false})
            this.dataTable.fetch()
        }).catch(() => {
            this.setState({uploading: false})
        })
    }

    onLocationModalOpen = (record) => {
        this.setState({
            locationModalVisible: true,
            locationModalRecord: record
        })
    }

    onLocationModalOk = (fieldsValue) => {
        this.setState({
            locationModalSaving: true
        })
        api.updateOrderMouldLocation(fieldsValue).then(() => {
            this.setState({
                locationModalSaving: false,
                locationModalVisible: false
            })
            this.dataTable.fetch()
        }).catch(() => {
            this.setState({
                locationModalSaving: false
            })
        })
    }

    onDelete = (mouldNo) => {
        api.deleteOrderMould(mouldNo).then(() => {
            this.dataTable.fetch()
        })
    }

    render() {
        return (
            <PageHeaderLayout title={'模具管理'} content={(
                <div style={{textAlign: 'center'}}>
                    <Input.Search style={{width: 500}}
                                  enterButton="搜索"
                                  onSearch={(value) => this.setState({searchKeyword: value})}
                    />
                </div>
            )}>
                <Card>
                    <div style={{marginBottom: 10}}>
                        <UploadButton onClick={() => this.setState({uploadModalVisible: true})}
                                      type={'primary'}>上传</UploadButton>
                    </div>
                    <StandardTable url={'/api/order/mould/'}
                                   rowKey={'mould_no'}
                                   columns={this.columns}
                                   ref={ref => this.dataTable = ref}
                                   keyword={this.state.searchKeyword}
                    />
                </Card>
                <Modal visible={this.state.uploadModalVisible}
                       onOk={this.onUploadModalOk}
                       onCancel={() => this.setState({uploadModalVisible: false})}
                       afterClose={() => this.setState({files: []})}
                       confirmLoading={this.state.uploading}
                       destroyOnClose
                >
                    <Upload accept='image/*,.pdf'
                            multiple
                            beforeUpload={(file) => {
                                this.setState((state) => ({files: [...state.files, file]}))
                                return false
                            }}
                            onRemove={(file) => {
                                const files = this.state.files
                                files.splice(files.indexOf(file), 1)
                                this.setState({
                                    files: files
                                })
                            }}
                    >
                        <Button>
                            <Icon type="upload"/>选择刀模
                        </Button>
                    </Upload>
                </Modal>
                <FormModal visible={this.state.locationModalVisible}
                           confirmLoading={this.state.locationModalSaving}
                           fields={this.locationFields}
                           record={this.state.locationModalRecord}
                           onCancel={() => this.setState({locationModalVisible: false})}
                           onOk={this.onLocationModalOk}
                />
            </PageHeaderLayout>
        );
    }
}

export default OrderMould;
